import {
    AfterContentInit, Directive, EmbeddedViewRef, Inject,
    Input, OnDestroy, SkipSelf,
    TemplateRef, ViewContainerRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { CommonToggleDisplayComponent } from "./common-toggle-display.component";
import { TOGGLE_DISPLAY_STATE_PROP } from "./state-props";

@Directive({
    selector: "[ispToggleDisplay]",
})
export class ToggledContentSelectedDirective implements AfterContentInit, OnDestroy {
    @Input()
    public set ispToggleDisplay(identifier: any) { this.identifier = identifier; }
    public identifier: any;
    public selectedIdentifier: any;
    public viewRef?: EmbeddedViewRef<any>;
    private state$: Subscription;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        public view: ViewContainerRef,
        public template: TemplateRef<any>,
        @SkipSelf() public context: CommonToggleDisplayComponent,
        @Inject(TOGGLE_DISPLAY_STATE_PROP) public rootProp,
    ) { }

    public ngAfterContentInit() {
        this.state$ = this.ngRedux.select(this.rootProp, this.context.stateProp).subscribe((state) => {
            setTimeout(() => {
                this.selectedIdentifier = state.selectedIndex;
                if (this.identifier === this.selectedIdentifier) {
                    this.addView();
                } else {
                    this.removeView();
                }
            });
        });
    }

    public addView() {
        if (this.viewRef === undefined) {
            this.viewRef = this.view.createEmbeddedView(this.template);
        }
    }

    public removeView() {
        if (this.viewRef !== undefined) {
            this.view.remove();
            this.viewRef = undefined;
        }
    }

    public ngOnDestroy() {
        this.removeView();
        this.state$.unsubscribe();
    }

}
